/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AnalitoParaEscolhaResponse,
  CatalogoExameDetalheResponse,
  CatalogoExamesConsultaControllerBuscarAnalitosParams,
  CatalogoExamesConsultaControllerListarParams,
  ErroResponse,
  PaginaDeCatalogoExamesResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCatalogoExamesConsultaControllerListarUrl = (params?: CatalogoExamesConsultaControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/catalogo-exames?${stringifiedParams}` : `/v1/catalogo-exames`
}

/**
 * @summary Lista o catálogo de exames ativos, pra escolher o tipo ao solicitar um exame
 */
export const catalogoExamesConsultaControllerListar = async (params?: CatalogoExamesConsultaControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeCatalogoExamesResponse> => {

  return httpClient<PaginaDeCatalogoExamesResponse>(getCatalogoExamesConsultaControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCatalogoExamesConsultaControllerListarQueryKey = (params?: CatalogoExamesConsultaControllerListarParams,) => {
    return [
    `/v1/catalogo-exames`, ...(params ? [params] : [])
    ] as const;
    }


export const getCatalogoExamesConsultaControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof catalogoExamesConsultaControllerListar>>, TError = unknown>(params?: CatalogoExamesConsultaControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesConsultaControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCatalogoExamesConsultaControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof catalogoExamesConsultaControllerListar>>> = ({ signal }) => catalogoExamesConsultaControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesConsultaControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CatalogoExamesConsultaControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof catalogoExamesConsultaControllerListar>>>
export type CatalogoExamesConsultaControllerListarQueryError = unknown


export function useCatalogoExamesConsultaControllerListar<TData = Awaited<ReturnType<typeof catalogoExamesConsultaControllerListar>>, TError = unknown>(
 params: undefined |  CatalogoExamesConsultaControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesConsultaControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoExamesConsultaControllerListar>>,
          TError,
          Awaited<ReturnType<typeof catalogoExamesConsultaControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoExamesConsultaControllerListar<TData = Awaited<ReturnType<typeof catalogoExamesConsultaControllerListar>>, TError = unknown>(
 params?: CatalogoExamesConsultaControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesConsultaControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoExamesConsultaControllerListar>>,
          TError,
          Awaited<ReturnType<typeof catalogoExamesConsultaControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoExamesConsultaControllerListar<TData = Awaited<ReturnType<typeof catalogoExamesConsultaControllerListar>>, TError = unknown>(
 params?: CatalogoExamesConsultaControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesConsultaControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista o catálogo de exames ativos, pra escolher o tipo ao solicitar um exame
 */

export function useCatalogoExamesConsultaControllerListar<TData = Awaited<ReturnType<typeof catalogoExamesConsultaControllerListar>>, TError = unknown>(
 params?: CatalogoExamesConsultaControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesConsultaControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCatalogoExamesConsultaControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCatalogoExamesConsultaControllerBuscarAnalitosUrl = (params?: CatalogoExamesConsultaControllerBuscarAnalitosParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/catalogo-exames/analitos?${stringifiedParams}` : `/v1/catalogo-exames/analitos`
}

/**
 * @summary Busca analitos ativos em todo o catálogo (nome, apelido ou nome do item) — para ligar o valor de um laudo externo a um analito
 */
export const catalogoExamesConsultaControllerBuscarAnalitos = async (params?: CatalogoExamesConsultaControllerBuscarAnalitosParams, options?: Parameters<typeof httpClient>[1]): Promise<AnalitoParaEscolhaResponse[]> => {

  return httpClient<AnalitoParaEscolhaResponse[]>(getCatalogoExamesConsultaControllerBuscarAnalitosUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCatalogoExamesConsultaControllerBuscarAnalitosQueryKey = (params?: CatalogoExamesConsultaControllerBuscarAnalitosParams,) => {
    return [
    `/v1/catalogo-exames/analitos`, ...(params ? [params] : [])
    ] as const;
    }


export const getCatalogoExamesConsultaControllerBuscarAnalitosQueryOptions = <TData = Awaited<ReturnType<typeof catalogoExamesConsultaControllerBuscarAnalitos>>, TError = unknown>(params?: CatalogoExamesConsultaControllerBuscarAnalitosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesConsultaControllerBuscarAnalitos>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCatalogoExamesConsultaControllerBuscarAnalitosQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof catalogoExamesConsultaControllerBuscarAnalitos>>> = ({ signal }) => catalogoExamesConsultaControllerBuscarAnalitos(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesConsultaControllerBuscarAnalitos>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CatalogoExamesConsultaControllerBuscarAnalitosQueryResult = NonNullable<Awaited<ReturnType<typeof catalogoExamesConsultaControllerBuscarAnalitos>>>
export type CatalogoExamesConsultaControllerBuscarAnalitosQueryError = unknown


export function useCatalogoExamesConsultaControllerBuscarAnalitos<TData = Awaited<ReturnType<typeof catalogoExamesConsultaControllerBuscarAnalitos>>, TError = unknown>(
 params: undefined |  CatalogoExamesConsultaControllerBuscarAnalitosParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesConsultaControllerBuscarAnalitos>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoExamesConsultaControllerBuscarAnalitos>>,
          TError,
          Awaited<ReturnType<typeof catalogoExamesConsultaControllerBuscarAnalitos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoExamesConsultaControllerBuscarAnalitos<TData = Awaited<ReturnType<typeof catalogoExamesConsultaControllerBuscarAnalitos>>, TError = unknown>(
 params?: CatalogoExamesConsultaControllerBuscarAnalitosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesConsultaControllerBuscarAnalitos>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoExamesConsultaControllerBuscarAnalitos>>,
          TError,
          Awaited<ReturnType<typeof catalogoExamesConsultaControllerBuscarAnalitos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoExamesConsultaControllerBuscarAnalitos<TData = Awaited<ReturnType<typeof catalogoExamesConsultaControllerBuscarAnalitos>>, TError = unknown>(
 params?: CatalogoExamesConsultaControllerBuscarAnalitosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesConsultaControllerBuscarAnalitos>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Busca analitos ativos em todo o catálogo (nome, apelido ou nome do item) — para ligar o valor de um laudo externo a um analito
 */

export function useCatalogoExamesConsultaControllerBuscarAnalitos<TData = Awaited<ReturnType<typeof catalogoExamesConsultaControllerBuscarAnalitos>>, TError = unknown>(
 params?: CatalogoExamesConsultaControllerBuscarAnalitosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesConsultaControllerBuscarAnalitos>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCatalogoExamesConsultaControllerBuscarAnalitosQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCatalogoExamesConsultaControllerObterUrl = (id: string,) => {




  return `/v1/catalogo-exames/${id}`
}

/**
 * @summary Detalha um item do catálogo com seus analitos — pra saber o que lançar depois
 */
export const catalogoExamesConsultaControllerObter = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<CatalogoExameDetalheResponse> => {

  return httpClient<CatalogoExameDetalheResponse>(getCatalogoExamesConsultaControllerObterUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCatalogoExamesConsultaControllerObterQueryKey = (id: string,) => {
    return [
    `/v1/catalogo-exames/${id}`
    ] as const;
    }


export const getCatalogoExamesConsultaControllerObterQueryOptions = <TData = Awaited<ReturnType<typeof catalogoExamesConsultaControllerObter>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesConsultaControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCatalogoExamesConsultaControllerObterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof catalogoExamesConsultaControllerObter>>> = ({ signal }) => catalogoExamesConsultaControllerObter(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesConsultaControllerObter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CatalogoExamesConsultaControllerObterQueryResult = NonNullable<Awaited<ReturnType<typeof catalogoExamesConsultaControllerObter>>>
export type CatalogoExamesConsultaControllerObterQueryError = ErroResponse


export function useCatalogoExamesConsultaControllerObter<TData = Awaited<ReturnType<typeof catalogoExamesConsultaControllerObter>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesConsultaControllerObter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoExamesConsultaControllerObter>>,
          TError,
          Awaited<ReturnType<typeof catalogoExamesConsultaControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoExamesConsultaControllerObter<TData = Awaited<ReturnType<typeof catalogoExamesConsultaControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesConsultaControllerObter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoExamesConsultaControllerObter>>,
          TError,
          Awaited<ReturnType<typeof catalogoExamesConsultaControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoExamesConsultaControllerObter<TData = Awaited<ReturnType<typeof catalogoExamesConsultaControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesConsultaControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha um item do catálogo com seus analitos — pra saber o que lançar depois
 */

export function useCatalogoExamesConsultaControllerObter<TData = Awaited<ReturnType<typeof catalogoExamesConsultaControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoExamesConsultaControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCatalogoExamesConsultaControllerObterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






